// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.basic-data__title{
    grid-column-start: 2;
    grid-column-end: 5;
}
.basic-data__title__color{
    color: var(--primary-very-dark-color);
}

.basic-data__form {
    grid-column-start: 2;
    grid-column-end: 10;
    margin-top: var(--space-and-half);
}

.basic-data__form__content .baloa-subtitle-2 {
    color: var( --primary-very-dark-color );
}

.basic-data__form__content__input.name {
    margin-top: calc( var( --space-x2 ) + var( --space-half ) + var( --space-eighth ) );
    margin-bottom: var( --space-and-half );
}

.basic-data__form__content__input .input-field-label
{
    font-weight: var(--font-regular);
    color: var(--primary-very-dark-color);
}

.basic-data__form__form__input__gender {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-bottom: var(--space-x2);
    grid-column-start: 1;
    grid-column-end: 4;
}

.basic-data__form__form__input__gender.baloa-body-2 {
    color: var(--primary-dark-color) !important;
    flex-basis: 100%;
    text-transform: uppercase;
    margin-bottom: var(--space-half);
    font-weight: var(--font-bold);
    font-size: var(--space-half-quarter);
    letter-spacing: 0.004em;
    margin-left: 0px !important
}

.basic-data__form__form__input-gender p{
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: var(--font-bold) !important;
    font-size: calc(var(--space-half-quarter) - 1px);
    line-height: var(--font-normal);
    display: flex;
    align-items: center;
    text-align: center;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: var(--primary-very-dark-color);
}

.basic-data__form__form__input-gender {
    border: 2px solid var(--mid-gray-color);
    border-radius: var(--space-and-half);
    box-sizing: border-box;
    display: flex;
    align-items: center;
    padding: var(--space-half) var(--space);
    height: var(--space-and-half);
    justify-content: center;
}

.basic-data__form__form__input-gender.selected {
    border: 2px solid var(--secondary-light-color);
    border-radius: var(--space-and-half);
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: var(--space-half) var(--space);
    height: var(--space-and-half);
}

.grid-content{
    display: grid;
    grid-template-columns: repeat(6, 1fr) !important;
    gap: var(--space-and-half);
}

.tournament-basic-data__description {
    margin: var( --space-and-half ) 0;
}

.tournament-basic-data__rules {
    margin-top: 0;
    margin-bottom: var( --space-and-half );
}

.basic-data__form__content__gender__input{
    grid-column-start: 4;
    grid-column-end: 7;
    margin-bottom: var(--space-x2);
}

.basic-data__form__content__football-type__input {
    grid-column-start: 1;
    grid-column-end: 4;
    margin-bottom: var( --space-and-half );    
}

.basic-data__form__content__tournament-type__input{
    grid-column-start: 4;
    grid-column-end: 7;
    margin-bottom: var(--space-and-half);
}

.basic-data__form__content__category__input {
    grid-column-start: 1;
    grid-column-end: 4;
    margin-bottom: var( --space-x3 );
}

.basic-data__form__content__gender__input .baloa-body-2 {
    font-size: var(--space);
}
.basic-data__form__content__gender__input .MuiInput-underline.select-field-input:hover:not(.Mui-disabled):before{
    border: none !important;
}

.basic-data__form__content__gender__input .MuiInput-underline.select-field-input:before{
    border: none;
    transition: none;
}
.basic-data__form__content__gender__input .MuiInputBase-root .MuiInput-root .MuiInput-underline .select-field-input  .Mui-focused .Mui-focused{
    border-style: none !important;
}

.basic-data__form__content__gender__input .select-field .select-field-label{
    left: -3px;
    padding: var(--space-half);
    font-weight: var(--font-regular);
    color: var(--primary-very-dark-color);
}

.basic-data__form__content__gender__input .MuiSelect-select.MuiSelect-select{
    padding: var(--space-half);
}

.basic-data__form__content__category__input .baloa-body-2 {
    font-size: var(--space);
}
.basic-data__form__content__category__input .MuiInput-underline.select-field-input:hover:not(.Mui-disabled):before,
.basic-data__form__content__football-type__input .MuiInput-underline.select-field-input:hover:not(.Mui-disabled):before,
.basic-data__form__content__tournament-type__input .MuiInput-underline.select-field-input:hover:not(.Mui-disabled):before{
    border: none !important;
}

.basic-data__form__content__category__input .MuiInput-underline.select-field-input:before,
.basic-data__form__content__football-type__input .MuiInput-underline.select-field-input:before,
.basic-data__form__content__tournament-type__input .MuiInput-underline.select-field-input:before{
    border: none;
    transition: none;
}
.basic-data__form__content__category__input .MuiInputBase-root .MuiInput-root .MuiInput-underline .select-field-input  .Mui-focused .Mui-focused,
.basic-data__form__content__football-type__input .MuiInputBase-root .MuiInput-root .MuiInput-underline .select-field-input  .Mui-focused .Mui-focused,
.basic-data__form__content__tournament-type__input .MuiInputBase-root .MuiInput-root .MuiInput-underline .select-field-input  .Mui-focused .Mui-focused{
    border-style: none !important;
}

.basic-data__form__content__category__input .select-field .select-field-label,
.basic-data__form__content__football-type__input .select-field .select-field-label,
.basic-data__form__content__tournament-type__input .select-field .select-field-label{
    left: -3px;
    padding: var(--space-half);
    font-weight: var(--font-regular);
    color: var(--primary-very-dark-color);
}

.basic-data__form__content__category__input .MuiSelect-select.MuiSelect-select,
.basic-data__form__content__football-type__input .MuiSelect-select.MuiSelect-select,
.basic-data__form__content__tournament-type__input .MuiSelect-select.MuiSelect-select{
    padding: var(--space-half);
}

.basic-data__form__content__city .MuiAutocomplete-root{
    grid-column-start: 1;
    grid-column-end: 4;
    margin-top: 0;
}
.basic-data__form__content__city__input{
    grid-column-start: 4;
    grid-column-end: 7;
    margin-top: 0;
}
.basic-data__form__content__country__input {
    grid-column-start: 1;
    grid-column-end: 4;
    margin-top: 0;
    margin-bottom: var( --space-and-half );
}
/* .basic-data__form__content__date.grid-content {} */

.basic-data__form__content__date__input-start {
    grid-column-start: 1;
    grid-column-end: 4;
    margin-top: 0 ;
    margin-bottom: 0 ;
    /* z-index: 2 */
}

.basic-data__form__content__date__input-start input{
    padding: var(--space) var(--space-quarter);
    /* position: initial; */
}

.basic-data__form__content__date__input-start label,
.basic-data__form__content__date__input-end label,
.tournament-basic-data__description label.baloa-names,
.tournament-basic-data__rules label.baloa-names,
.basic-data__button-group .baloa-names
{
    font-weight: var(--font-regular);
    color: var(--primary-very-dark-color);
}

.basic-data__form__content__date__input-end {
    grid-column-start: 4;
    grid-column-end: 7;
    margin-top: 0 ;
    margin-bottom: 0 ;
}
.basic-data__form__content__date__input-end input{
    padding: var(--space) var(--space-quarter);
}

.basic-data__form__content__country__input .MuiAutocomplete-popupIndicator { 
    display: none;
}

.basic-data__form__content__city__input .MuiAutocomplete-popupIndicator { 
    display: none;
}

.basic-data__form__content__category__input .select-field-icon{
    display: none;
}

.basic-data__form__content__category__input .select-field,
.basic-data__form__content__gender__input .select-field {
    margin: 0;
}

.basic-data__form__content__football-type__input .select-field {
    margin-bottom: 0;
}

.tournament-basic-data__game-days__container {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.tournament-basic-data__week-day,
.tournament-basic-data__day-time {
    border: 1px solid var( --new-gray-background-color );
    border-radius: var( --space-half );
    padding: var( --space );
}

.tournament-basic-data__game-days,
.tournament-basic-data__matches-day-time {
    margin-top: var( --space-and-half );
}

.tournament-basic-data__game-days__label.baloa-username,
.tournament-basic-data__matches-day-time__label.baloa-username {
    margin-bottom: var( --space-half );
    color: var( --primary-very-dark-color );
}

.basic-data__form__content .select-field-input,
.basic-data__form__content .input-field-autocomplete-search div,
.basic-data__form__content .input-field-input,
.basic-data__form__content .input-field-multiline-input {
    background-color: var( --white-color );
    border: 1px solid var( --new-gray-background-color ) ;
    border-radius: 8px;
    font-size: 14px;
    line-height: 16px;
}

.basic-data__form__content .input-field-autocomplete-search label{
    font-weight: var(--font-regular);
    color: var(--primary-very-dark-color);
}

.basic-data__form__content .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"] .MuiAutocomplete-endAdornment {
    border: none;
}

.tournament-basic-data__matches-day-time__container {
    display: flex;
    justify-content: flex-start;
}

.tournament-basic-data__matches-day-time__container div {
    margin-right: calc( var( --space ) + var ( --space-eighth ) );
}

.tournament-basic-data__logo__required-label.baloa-username {
    color: var(--error-color);
 }

.tournament-basic-data__photo__required-label.baloa-username {
    color: var(--error-color);
    text-align: center;
    margin-top: var( --space-half );
    margin-bottom: var( --space-x2 );
}

.tournament-basic-data__tournament-logo .tournament-photo img {
    width: 142px;
    height: 142px;
    border-radius: 50%;
    justify-content: center;
    position: absolute;
}

.tournament-basic-data__tournament-logo .tournament-photo {
    width: 142px;
    height: 142px;
    border-radius: 50%;
    border: 1px dashed #7f9088;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: calc( var( --space-half-quarter ) + var( --space-eighth ) );
    cursor: pointer;
    background-color: #FAF8F8;
    position: relative;
}

.tournament-basic-data__tournament-logo .tournament-photo .baloa-username,
.tournament-basic-data__tournament-cover .tournament-cover .baloa-username {
    color: var( --new-green-color );
    font-weight: var( --font-medium );
    margin-left: var( --space-half );
}

.tournament-basic-data__tournament-logo .tournament-photo span {
    color: var( --new-green-color );
    font-size: var( --space );
}

.tournament-basic-data__tournament-logo,
.tournament-basic-data__tournament-cover {
    display: flex;
    align-items: center;
    flex-direction: column;
}

.tournament-basic-data__tournament-cover__tittle .baloa-username{
    justify-content: flex-start;
}

.tournament-basic-data__tournament-cover .tournament-cover {
    width: 406px;
    height: 222px;
    border-radius: var( --space-half );
    border: 1px dashed #7f9088;    
    display: flex;
    flex-direction: column;
    align-items: center;    
    color: var( --new-green-color );
    justify-content: flex-end;
    margin-top: calc( var( --space-half-quarter ) + var( --space-eighth ) );
    margin-bottom: var( --space );
    cursor: pointer;
    background-color: #FAF8F8;
}

.tournament-cover-description{
    display: flex;
    align-items: center;
}
.tournament-cover-info{
    display: flex;
    align-items: center;
    color: var(--basic-gray-color);
    margin-top: 70px;
    margin-bottom: 20px;
}

.tournament-cover .tournament-cover-info .baloa-username{
    color: var(--basic-gray-color);
    font-weight: var(--font-regular);
}

.tournament-cover-info .hubicon-info{
    font-size: 15px;
}

.tournament-basic-data__tournament-cover .img-container {
    width: 406px;
    height: 222px;
}

.tournament-basic-data__tournament-cover .img-container img{
    width: 100%;
}

.tournament-basic-data__tournament-logo {
    margin-top: var( --space-x2 );
}

.basic-data__form__content .input-field-multiline__message,
.basic-data__form__content .select-field__message,
.basic-data__form__content .input-field-autocomplete-search__message {
    color: var(--error-color);
}

.basic-data__tournament-cover__modal .profile-new-photo__content__result__container__loader {
    width: 100%;
}

.basic-data__button-group button.MuiButtonBase-root.MuiToggleButton-root.MuiToggleButtonGroup-grouped.MuiToggleButtonGroup-groupedHorizontal{
    border-radius: 9px;
    border: 1px solid var(--new-gray-background-color);
    color: var(--primary-dark-color);
}

.basic-data__button-group button.MuiButtonBase-root.MuiToggleButton-root.MuiToggleButtonGroup-grouped.MuiToggleButtonGroup-groupedHorizontal:hover{
    background-color: var(--new-green-color);
    color: var(--white-color);
}

.basic-data__button-group button.MuiButtonBase-root.MuiToggleButton-root.MuiToggleButtonGroup-grouped.MuiToggleButtonGroup-groupedHorizontal.Mui-selected{
    background-color: var(--new-green-color);
    color: var(--white-color);
}

.basic-data__button-group button.MuiButtonBase-root.MuiToggleButton-root.Mui-selected{
    margin-left: 8px;
}


.basic-data__button-group span.MuiToggleButton-label {
    text-transform: initial;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    letter-spacing: 0.0025em;
}

.basic-data__button-group .MuiToggleButton-root.Mui-selected{
    color: var(--white-color);
    background-color: var(--new-green-color);
}

.basic-data__button-group .MuiToggleButton-root {
    border: 1px solid #E7E7E7;
    border-radius: 9px;
    padding: 20px;
    font-size: 0.875rem;
    box-sizing: border-box;
    font-weight: 500;
    line-height: 1.75;
    text-transform: uppercase;
}
.basic-data__button-group{
    margin-bottom: var(--space);
}

.basic-data__form__content__gender__input .select-field-input,
.basic-data__form__content__category__input .select-field-input,
.basic-data__form__content__football-type__input .select-field-input,
.basic-data__form__content__tournament-type__input .select-field-input{
    color: var(--basic-gray-color)
}

.input-field-auto-search.basic-data__form__content__country__input input,
.input-field-auto-search.basic-data__form__content__city__input input{
    font-size: 14px;
    line-height: 16px;
    color: var(--primary-very-dark-color);
}

.input-field-auto-search.basic-data__form__content__country__input .MuiInputBase-root input::placeholder,
.input-field-auto-search.basic-data__form__content__city__input .MuiInputBase-root input::placeholder{
    color: var(--primary-very-dark-color);
    opacity: 0.6;
}

.basic-data__fair-play-container {
    border: 1px solid var(--new-gray-background-color);
    border-radius: 8px;
    padding: 12px 16px;
    margin-top: var(--space-and-half);
}

.basic-data__fair-play-container .baloa-names {
    color: var(--primary-very-dark-color);
}


.basic-data__fair-play-container .baloa-table-column {
    font-weight: var(--font-regular);
    color: var(--primary-very-dark-color);
    margin-top: 12px;
}

.basic-data__fair-play-container .input-field {
    margin: 0;
    margin-top: 24px;
}

.basic-data__fair-play-container .input-field-label {
    color: var(--primary-very-dark-color);
    font-size: calc(var(--space-half-quarter) + var(--space-eighth) + 1px);
    font-weight: var(--font-regular);
}

.basic-data__fair-play-container .input-field-input {
    width: 80px;
    padding: 14px 12px;
    text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/tournament-basic-data/TournamentBasicDataComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,kBAAkB;AACtB;AACA;IACI,qCAAqC;AACzC;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,iCAAiC;AACrC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,mFAAmF;IACnF,sCAAsC;AAC1C;;AAEA;;IAEI,gCAAgC;IAChC,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,8BAA8B;IAC9B,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,2CAA2C;IAC3C,gBAAgB;IAChB,yBAAyB;IACzB,gCAAgC;IAChC,6BAA6B;IAC7B,oCAAoC;IACpC,uBAAuB;IACvB;AACJ;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,wCAAwC;IACxC,gDAAgD;IAChD,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB;IACzB,qCAAqC;AACzC;;AAEA;IACI,uCAAuC;IACvC,oCAAoC;IACpC,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,uCAAuC;IACvC,6BAA6B;IAC7B,uBAAuB;AAC3B;;AAEA;IACI,8CAA8C;IAC9C,oCAAoC;IACpC,sBAAsB;IACtB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,uCAAuC;IACvC,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD,0BAA0B;AAC9B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,sCAAsC;AAC1C;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,sCAAsC;AAC1C;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,uBAAuB;AAC3B;AACA;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,6BAA6B;AACjC;;AAEA;IACI,UAAU;IACV,0BAA0B;IAC1B,gCAAgC;IAChC,qCAAqC;AACzC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,uBAAuB;AAC3B;AACA;;;IAGI,uBAAuB;AAC3B;;AAEA;;;IAGI,YAAY;IACZ,gBAAgB;AACpB;AACA;;;IAGI,6BAA6B;AACjC;;AAEA;;;IAGI,UAAU;IACV,0BAA0B;IAC1B,gCAAgC;IAChC,qCAAqC;AACzC;;AAEA;;;IAGI,0BAA0B;AAC9B;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,aAAa;AACjB;AACA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,aAAa;AACjB;AACA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,aAAa;IACb,sCAAsC;AAC1C;AACA,qDAAqD;;AAErD;IACI,oBAAoB;IACpB,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,0CAA0C;IAC1C,uBAAuB;AAC3B;;AAEA;;;;;;IAMI,gCAAgC;IAChC,qCAAqC;AACzC;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,cAAc;IACd,iBAAiB;AACrB;AACA;IACI,0CAA0C;AAC9C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;;IAEI,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;;IAEI,oDAAoD;IACpD,kCAAkC;IAClC,uBAAuB;AAC3B;;AAEA;;IAEI,mCAAmC;AACvC;;AAEA;;IAEI,kCAAkC;IAClC,uCAAuC;AAC3C;;AAEA;;;;IAII,sCAAsC;IACtC,qDAAqD;IACrD,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;IAChC,qCAAqC;AACzC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,2BAA2B;AAC/B;;AAEA;IACI,6DAA6D;AACjE;;AAEA;IACI,yBAAyB;CAC5B;;AAED;IACI,yBAAyB;IACzB,kBAAkB;IAClB,+BAA+B;IAC/B,gCAAgC;AACpC;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mEAAmE;IACnE,eAAe;IACf,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;;IAEI,+BAA+B;IAC/B,iCAAiC;IACjC,gCAAgC;AACpC;;AAEA;IACI,+BAA+B;IAC/B,yBAAyB;AAC7B;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kCAAkC;IAClC,0BAA0B;IAC1B,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,+BAA+B;IAC/B,yBAAyB;IACzB,uEAAuE;IACvE,6BAA6B;IAC7B,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,gCAAgC;AACpC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,6BAA6B;AACjC;;AAEA;;;IAGI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,kDAAkD;IAClD,gCAAgC;AACpC;;AAEA;IACI,wCAAwC;IACxC,yBAAyB;AAC7B;;AAEA;IACI,wCAAwC;IACxC,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;;AAGA;IACI,uBAAuB;IACvB,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;IACzB,wCAAwC;AAC5C;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;AAC7B;AACA;IACI,2BAA2B;AAC/B;;AAEA;;;;IAII;AACJ;;AAEA;;IAEI,eAAe;IACf,iBAAiB;IACjB,qCAAqC;AACzC;;AAEA;;IAEI,qCAAqC;IACrC,YAAY;AAChB;;AAEA;IACI,kDAAkD;IAClD,kBAAkB;IAClB,kBAAkB;IAClB,iCAAiC;AACrC;;AAEA;IACI,qCAAqC;AACzC;;;AAGA;IACI,gCAAgC;IAChC,qCAAqC;IACrC,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;IACrC,sEAAsE;IACtE,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,kBAAkB;AACtB","sourcesContent":[".basic-data__title{\n    grid-column-start: 2;\n    grid-column-end: 5;\n}\n.basic-data__title__color{\n    color: var(--primary-very-dark-color);\n}\n\n.basic-data__form {\n    grid-column-start: 2;\n    grid-column-end: 10;\n    margin-top: var(--space-and-half);\n}\n\n.basic-data__form__content .baloa-subtitle-2 {\n    color: var( --primary-very-dark-color );\n}\n\n.basic-data__form__content__input.name {\n    margin-top: calc( var( --space-x2 ) + var( --space-half ) + var( --space-eighth ) );\n    margin-bottom: var( --space-and-half );\n}\n\n.basic-data__form__content__input .input-field-label\n{\n    font-weight: var(--font-regular);\n    color: var(--primary-very-dark-color);\n}\n\n.basic-data__form__form__input__gender {\n    display: flex;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    margin-bottom: var(--space-x2);\n    grid-column-start: 1;\n    grid-column-end: 4;\n}\n\n.basic-data__form__form__input__gender.baloa-body-2 {\n    color: var(--primary-dark-color) !important;\n    flex-basis: 100%;\n    text-transform: uppercase;\n    margin-bottom: var(--space-half);\n    font-weight: var(--font-bold);\n    font-size: var(--space-half-quarter);\n    letter-spacing: 0.004em;\n    margin-left: 0px !important\n}\n\n.basic-data__form__form__input-gender p{\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: var(--font-bold) !important;\n    font-size: calc(var(--space-half-quarter) - 1px);\n    line-height: var(--font-normal);\n    display: flex;\n    align-items: center;\n    text-align: center;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    color: var(--primary-very-dark-color);\n}\n\n.basic-data__form__form__input-gender {\n    border: 2px solid var(--mid-gray-color);\n    border-radius: var(--space-and-half);\n    box-sizing: border-box;\n    display: flex;\n    align-items: center;\n    padding: var(--space-half) var(--space);\n    height: var(--space-and-half);\n    justify-content: center;\n}\n\n.basic-data__form__form__input-gender.selected {\n    border: 2px solid var(--secondary-light-color);\n    border-radius: var(--space-and-half);\n    box-sizing: border-box;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: var(--space-half) var(--space);\n    height: var(--space-and-half);\n}\n\n.grid-content{\n    display: grid;\n    grid-template-columns: repeat(6, 1fr) !important;\n    gap: var(--space-and-half);\n}\n\n.tournament-basic-data__description {\n    margin: var( --space-and-half ) 0;\n}\n\n.tournament-basic-data__rules {\n    margin-top: 0;\n    margin-bottom: var( --space-and-half );\n}\n\n.basic-data__form__content__gender__input{\n    grid-column-start: 4;\n    grid-column-end: 7;\n    margin-bottom: var(--space-x2);\n}\n\n.basic-data__form__content__football-type__input {\n    grid-column-start: 1;\n    grid-column-end: 4;\n    margin-bottom: var( --space-and-half );    \n}\n\n.basic-data__form__content__tournament-type__input{\n    grid-column-start: 4;\n    grid-column-end: 7;\n    margin-bottom: var(--space-and-half);\n}\n\n.basic-data__form__content__category__input {\n    grid-column-start: 1;\n    grid-column-end: 4;\n    margin-bottom: var( --space-x3 );\n}\n\n.basic-data__form__content__gender__input .baloa-body-2 {\n    font-size: var(--space);\n}\n.basic-data__form__content__gender__input .MuiInput-underline.select-field-input:hover:not(.Mui-disabled):before{\n    border: none !important;\n}\n\n.basic-data__form__content__gender__input .MuiInput-underline.select-field-input:before{\n    border: none;\n    transition: none;\n}\n.basic-data__form__content__gender__input .MuiInputBase-root .MuiInput-root .MuiInput-underline .select-field-input  .Mui-focused .Mui-focused{\n    border-style: none !important;\n}\n\n.basic-data__form__content__gender__input .select-field .select-field-label{\n    left: -3px;\n    padding: var(--space-half);\n    font-weight: var(--font-regular);\n    color: var(--primary-very-dark-color);\n}\n\n.basic-data__form__content__gender__input .MuiSelect-select.MuiSelect-select{\n    padding: var(--space-half);\n}\n\n.basic-data__form__content__category__input .baloa-body-2 {\n    font-size: var(--space);\n}\n.basic-data__form__content__category__input .MuiInput-underline.select-field-input:hover:not(.Mui-disabled):before,\n.basic-data__form__content__football-type__input .MuiInput-underline.select-field-input:hover:not(.Mui-disabled):before,\n.basic-data__form__content__tournament-type__input .MuiInput-underline.select-field-input:hover:not(.Mui-disabled):before{\n    border: none !important;\n}\n\n.basic-data__form__content__category__input .MuiInput-underline.select-field-input:before,\n.basic-data__form__content__football-type__input .MuiInput-underline.select-field-input:before,\n.basic-data__form__content__tournament-type__input .MuiInput-underline.select-field-input:before{\n    border: none;\n    transition: none;\n}\n.basic-data__form__content__category__input .MuiInputBase-root .MuiInput-root .MuiInput-underline .select-field-input  .Mui-focused .Mui-focused,\n.basic-data__form__content__football-type__input .MuiInputBase-root .MuiInput-root .MuiInput-underline .select-field-input  .Mui-focused .Mui-focused,\n.basic-data__form__content__tournament-type__input .MuiInputBase-root .MuiInput-root .MuiInput-underline .select-field-input  .Mui-focused .Mui-focused{\n    border-style: none !important;\n}\n\n.basic-data__form__content__category__input .select-field .select-field-label,\n.basic-data__form__content__football-type__input .select-field .select-field-label,\n.basic-data__form__content__tournament-type__input .select-field .select-field-label{\n    left: -3px;\n    padding: var(--space-half);\n    font-weight: var(--font-regular);\n    color: var(--primary-very-dark-color);\n}\n\n.basic-data__form__content__category__input .MuiSelect-select.MuiSelect-select,\n.basic-data__form__content__football-type__input .MuiSelect-select.MuiSelect-select,\n.basic-data__form__content__tournament-type__input .MuiSelect-select.MuiSelect-select{\n    padding: var(--space-half);\n}\n\n.basic-data__form__content__city .MuiAutocomplete-root{\n    grid-column-start: 1;\n    grid-column-end: 4;\n    margin-top: 0;\n}\n.basic-data__form__content__city__input{\n    grid-column-start: 4;\n    grid-column-end: 7;\n    margin-top: 0;\n}\n.basic-data__form__content__country__input {\n    grid-column-start: 1;\n    grid-column-end: 4;\n    margin-top: 0;\n    margin-bottom: var( --space-and-half );\n}\n/* .basic-data__form__content__date.grid-content {} */\n\n.basic-data__form__content__date__input-start {\n    grid-column-start: 1;\n    grid-column-end: 4;\n    margin-top: 0 ;\n    margin-bottom: 0 ;\n    /* z-index: 2 */\n}\n\n.basic-data__form__content__date__input-start input{\n    padding: var(--space) var(--space-quarter);\n    /* position: initial; */\n}\n\n.basic-data__form__content__date__input-start label,\n.basic-data__form__content__date__input-end label,\n.tournament-basic-data__description label.baloa-names,\n.tournament-basic-data__rules label.baloa-names,\n.basic-data__button-group .baloa-names\n{\n    font-weight: var(--font-regular);\n    color: var(--primary-very-dark-color);\n}\n\n.basic-data__form__content__date__input-end {\n    grid-column-start: 4;\n    grid-column-end: 7;\n    margin-top: 0 ;\n    margin-bottom: 0 ;\n}\n.basic-data__form__content__date__input-end input{\n    padding: var(--space) var(--space-quarter);\n}\n\n.basic-data__form__content__country__input .MuiAutocomplete-popupIndicator { \n    display: none;\n}\n\n.basic-data__form__content__city__input .MuiAutocomplete-popupIndicator { \n    display: none;\n}\n\n.basic-data__form__content__category__input .select-field-icon{\n    display: none;\n}\n\n.basic-data__form__content__category__input .select-field,\n.basic-data__form__content__gender__input .select-field {\n    margin: 0;\n}\n\n.basic-data__form__content__football-type__input .select-field {\n    margin-bottom: 0;\n}\n\n.tournament-basic-data__game-days__container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.tournament-basic-data__week-day,\n.tournament-basic-data__day-time {\n    border: 1px solid var( --new-gray-background-color );\n    border-radius: var( --space-half );\n    padding: var( --space );\n}\n\n.tournament-basic-data__game-days,\n.tournament-basic-data__matches-day-time {\n    margin-top: var( --space-and-half );\n}\n\n.tournament-basic-data__game-days__label.baloa-username,\n.tournament-basic-data__matches-day-time__label.baloa-username {\n    margin-bottom: var( --space-half );\n    color: var( --primary-very-dark-color );\n}\n\n.basic-data__form__content .select-field-input,\n.basic-data__form__content .input-field-autocomplete-search div,\n.basic-data__form__content .input-field-input,\n.basic-data__form__content .input-field-multiline-input {\n    background-color: var( --white-color );\n    border: 1px solid var( --new-gray-background-color ) ;\n    border-radius: 8px;\n    font-size: 14px;\n    line-height: 16px;\n}\n\n.basic-data__form__content .input-field-autocomplete-search label{\n    font-weight: var(--font-regular);\n    color: var(--primary-very-dark-color);\n}\n\n.basic-data__form__content .MuiAutocomplete-inputRoot[class*=\"MuiOutlinedInput-root\"] .MuiAutocomplete-endAdornment {\n    border: none;\n}\n\n.tournament-basic-data__matches-day-time__container {\n    display: flex;\n    justify-content: flex-start;\n}\n\n.tournament-basic-data__matches-day-time__container div {\n    margin-right: calc( var( --space ) + var ( --space-eighth ) );\n}\n\n.tournament-basic-data__logo__required-label.baloa-username {\n    color: var(--error-color);\n }\n\n.tournament-basic-data__photo__required-label.baloa-username {\n    color: var(--error-color);\n    text-align: center;\n    margin-top: var( --space-half );\n    margin-bottom: var( --space-x2 );\n}\n\n.tournament-basic-data__tournament-logo .tournament-photo img {\n    width: 142px;\n    height: 142px;\n    border-radius: 50%;\n    justify-content: center;\n    position: absolute;\n}\n\n.tournament-basic-data__tournament-logo .tournament-photo {\n    width: 142px;\n    height: 142px;\n    border-radius: 50%;\n    border: 1px dashed #7f9088;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: calc( var( --space-half-quarter ) + var( --space-eighth ) );\n    cursor: pointer;\n    background-color: #FAF8F8;\n    position: relative;\n}\n\n.tournament-basic-data__tournament-logo .tournament-photo .baloa-username,\n.tournament-basic-data__tournament-cover .tournament-cover .baloa-username {\n    color: var( --new-green-color );\n    font-weight: var( --font-medium );\n    margin-left: var( --space-half );\n}\n\n.tournament-basic-data__tournament-logo .tournament-photo span {\n    color: var( --new-green-color );\n    font-size: var( --space );\n}\n\n.tournament-basic-data__tournament-logo,\n.tournament-basic-data__tournament-cover {\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n}\n\n.tournament-basic-data__tournament-cover__tittle .baloa-username{\n    justify-content: flex-start;\n}\n\n.tournament-basic-data__tournament-cover .tournament-cover {\n    width: 406px;\n    height: 222px;\n    border-radius: var( --space-half );\n    border: 1px dashed #7f9088;    \n    display: flex;\n    flex-direction: column;\n    align-items: center;    \n    color: var( --new-green-color );\n    justify-content: flex-end;\n    margin-top: calc( var( --space-half-quarter ) + var( --space-eighth ) );\n    margin-bottom: var( --space );\n    cursor: pointer;\n    background-color: #FAF8F8;\n}\n\n.tournament-cover-description{\n    display: flex;\n    align-items: center;\n}\n.tournament-cover-info{\n    display: flex;\n    align-items: center;\n    color: var(--basic-gray-color);\n    margin-top: 70px;\n    margin-bottom: 20px;\n}\n\n.tournament-cover .tournament-cover-info .baloa-username{\n    color: var(--basic-gray-color);\n    font-weight: var(--font-regular);\n}\n\n.tournament-cover-info .hubicon-info{\n    font-size: 15px;\n}\n\n.tournament-basic-data__tournament-cover .img-container {\n    width: 406px;\n    height: 222px;\n}\n\n.tournament-basic-data__tournament-cover .img-container img{\n    width: 100%;\n}\n\n.tournament-basic-data__tournament-logo {\n    margin-top: var( --space-x2 );\n}\n\n.basic-data__form__content .input-field-multiline__message,\n.basic-data__form__content .select-field__message,\n.basic-data__form__content .input-field-autocomplete-search__message {\n    color: var(--error-color);\n}\n\n.basic-data__tournament-cover__modal .profile-new-photo__content__result__container__loader {\n    width: 100%;\n}\n\n.basic-data__button-group button.MuiButtonBase-root.MuiToggleButton-root.MuiToggleButtonGroup-grouped.MuiToggleButtonGroup-groupedHorizontal{\n    border-radius: 9px;\n    border: 1px solid var(--new-gray-background-color);\n    color: var(--primary-dark-color);\n}\n\n.basic-data__button-group button.MuiButtonBase-root.MuiToggleButton-root.MuiToggleButtonGroup-grouped.MuiToggleButtonGroup-groupedHorizontal:hover{\n    background-color: var(--new-green-color);\n    color: var(--white-color);\n}\n\n.basic-data__button-group button.MuiButtonBase-root.MuiToggleButton-root.MuiToggleButtonGroup-grouped.MuiToggleButtonGroup-groupedHorizontal.Mui-selected{\n    background-color: var(--new-green-color);\n    color: var(--white-color);\n}\n\n.basic-data__button-group button.MuiButtonBase-root.MuiToggleButton-root.Mui-selected{\n    margin-left: 8px;\n}\n\n\n.basic-data__button-group span.MuiToggleButton-label {\n    text-transform: initial;\n    font-family: 'Roboto';\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 0.0025em;\n}\n\n.basic-data__button-group .MuiToggleButton-root.Mui-selected{\n    color: var(--white-color);\n    background-color: var(--new-green-color);\n}\n\n.basic-data__button-group .MuiToggleButton-root {\n    border: 1px solid #E7E7E7;\n    border-radius: 9px;\n    padding: 20px;\n    font-size: 0.875rem;\n    box-sizing: border-box;\n    font-weight: 500;\n    line-height: 1.75;\n    text-transform: uppercase;\n}\n.basic-data__button-group{\n    margin-bottom: var(--space);\n}\n\n.basic-data__form__content__gender__input .select-field-input,\n.basic-data__form__content__category__input .select-field-input,\n.basic-data__form__content__football-type__input .select-field-input,\n.basic-data__form__content__tournament-type__input .select-field-input{\n    color: var(--basic-gray-color)\n}\n\n.input-field-auto-search.basic-data__form__content__country__input input,\n.input-field-auto-search.basic-data__form__content__city__input input{\n    font-size: 14px;\n    line-height: 16px;\n    color: var(--primary-very-dark-color);\n}\n\n.input-field-auto-search.basic-data__form__content__country__input .MuiInputBase-root input::placeholder,\n.input-field-auto-search.basic-data__form__content__city__input .MuiInputBase-root input::placeholder{\n    color: var(--primary-very-dark-color);\n    opacity: 0.6;\n}\n\n.basic-data__fair-play-container {\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 8px;\n    padding: 12px 16px;\n    margin-top: var(--space-and-half);\n}\n\n.basic-data__fair-play-container .baloa-names {\n    color: var(--primary-very-dark-color);\n}\n\n\n.basic-data__fair-play-container .baloa-table-column {\n    font-weight: var(--font-regular);\n    color: var(--primary-very-dark-color);\n    margin-top: 12px;\n}\n\n.basic-data__fair-play-container .input-field {\n    margin: 0;\n    margin-top: 24px;\n}\n\n.basic-data__fair-play-container .input-field-label {\n    color: var(--primary-very-dark-color);\n    font-size: calc(var(--space-half-quarter) + var(--space-eighth) + 1px);\n    font-weight: var(--font-regular);\n}\n\n.basic-data__fair-play-container .input-field-input {\n    width: 80px;\n    padding: 14px 12px;\n    text-align: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
